import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import HistoryIcon from '@mui/icons-material/History';
import TableRow from '@mui/material/TableRow';
import Table, { TableProps } from 'components/Table';
import TableCell from 'components/TableCell';
import FlightPriceHistoryRow from 'components/FlightPriceHistoryRow';

import { FlightPriceHistoryTable_history$key } from '__generated__/FlightPriceHistoryTable_history.graphql';

type Props = Omit<TableProps, 'pageInfo' | 'head'> & {
  history: FlightPriceHistoryTable_history$key | null;
  hideNotes?: boolean;
};

const FlightPriceHistoryTable: FC<Props> = props => {
  const { history, hideNotes, ...rest } = props;

  const { edges, pageInfo } =
    useFragment(
      graphql`
        fragment FlightPriceHistoryTable_history on FlightPriceConnection {
          edges {
            node {
              id
              ...FlightPriceHistoryRow_entry
            }
          }

          pageInfo {
            total

            ...Table_pageInfo
          }
        }
      `,
      history
    ) ?? {};

  return (
    <Table
      pagination
      pageInfo={pageInfo ?? null}
      icon={<HistoryIcon />}
      head={
        <TableRow>
          <TableCell>Data</TableCell>
          <TableCell center>Laikas</TableCell>
          <TableCell center>Pokytis</TableCell>
          <TableCell center>Kaina skrydžių sistemoje</TableCell>
          <TableCell center>Aktuali kaina</TableCell>
          {!hideNotes && <TableCell center>Pastabos</TableCell>}
        </TableRow>
      }
      {...rest}>
      {edges?.map(({ node }) => (
        <FlightPriceHistoryRow
          entry={node}
          key={node.id}
          hideNotes={hideNotes}
        />
      ))}
    </Table>
  );
};

export default FlightPriceHistoryTable;
